<div class="panel-content">
  <!--Bookmark Description".-->
  <div class="bookmark-description">Refine map view, label, and save.</div>
  <!--View 1 input + save button".-->
  <div id="view-1">
    <div id="save-view-view-2" style="display: block">
      <input id="save-view-title" class="panel-text-box" maxlength="100" placeholder="Enter label here" type="text"
        [(ngModel)]="value" style="width: 100%; float: center; margin: 0px 0px 10px 0px"
        (keyup.enter)="getBookMark()" />
      <a id="folder_icon" class="folder" (click)="createFolder()"><img title="Create a folder" class="folder-Icon"
          src="/assets/img/folder.png" /></a>
      <a id="save-view" class="btn btn-default" style="margin-left: 34%" (click)="getBookMark()">Save</a>
      <div class="modal-content" id="folder_menu" *ngIf="createFolderPop">
        <div class="modal-body modal-padding">
          <h5 class="folderModal">Create Folder</h5>
          <input id="rename-view-title" [(ngModel)]="title" class="panel-text-box1" maxlength="100"
            placeholder="Enter title here" type="text">
          <input id="rename-view-title" [(ngModel)]="subText" class="panel-text-box1" maxlength="100"
            placeholder="Enter subtitle here" type="text">
          <div class="button-wrapper">
            <button class="modal-button-style" id="rename_button" data-dismiss="modal" viewid="721" viewindex="0"
              (click)="save()">Save</button>
            <button class="modal-button-style" data-dismiss="modal" (click)="close()">Cancel</button>
          </div>
        </div>
      </div>
      <div class="button-container"></div>
      <!--multi delete.-->
      <!-- <div id="save-view-view-1" *ngIf="showDeleteIcon">
        <div
          (click)="deleteMultiple()"
          class="multi-delete-view"
          style="top: 290px; left: 199px; position: fixed"
        >
          <img src="/assets/img/table/addRedX2.png" /><span> Delete</span>
        </div>
      </div> -->
      <!--Book Mark Table-->
      <ng-container *ngFor="let bookMarkList of allBookMarks; index as i" style="overflow-y: scroll">
        <ul id="save-view-list">
          <li class="save-view-li-item" id="bookMark-{{ i }}" (click)="selectMultiPleBookMark($event, bookMarkList, i)">
            <span>
              <a [ngClass]="clickedIndex === i ? 'activeBtn' : ''" id="740" title="{{ bookMarkList.view_label }}"
                (click)="clickToZoom($event,bookMarkList, i)" [ngClass]="
                  bookMarkList.view_label === defaultView.view_label ||
                  (messagedefaultBookMark.id === bookMarkList.id &&
                    showDefaultMark)
                    ? 'save-view-item-bold'
                    : 'save-view-item'
                ">{{ bookMarkList.view_label }}</a>
            </span>
            <img class="action-menu-btn" src="/assets/img/table/3doticon.png" (mouseleave)="openFolderPanelHide()"
              (click)="showPanel(i, bookMarkList)" (click)="getPosition(i)" />
            <ul *ngIf="show === i" class="option-buttons" id="actionMenu{{ i }}">
              <ul class="foldersPanel" id="actionMenu{{ bookMarkList.id }}" *ngIf="openFoldersPanel">
                <li *ngFor="let folderList of bookMarkFolderView; index as i">
                  <span>
                    <a class="save-view-item" (click)="moveBookmark(folderList)">{{ folderList.title }}</a>
                  </span>
                </li>
                <span style="padding-left: 10px; opacity: 0.2">{{
                  removeFolder
                  }}</span>
              </ul>
              <li (mouseleave)="openFolderPanelHide()" (click)="setDefaultView(bookMarkList); selectedRow = i"
                class="default-view default-save mytooltip _tooltip" id="740-def"
                style="border-bottom: 1px solid #000 !important">
                <img src="/assets/img/tools/default.png" /><span class="def-txt">
                  {{ status }} Default View</span>
              </li>
              <li class="edit-view">
                <img src="/assets/img/folder.png" /><span [ngClass]="
                    bookMarkFolderView.length === 0 ? 'edit-view1' : ''
                  ">
                  Folder</span>
                <a class="next-win" (mouseenter)="openFolderPanel()" [ngClass]="
                    bookMarkFolderView.length === 0 ? 'edit-view1' : ''
                  "><img src="/assets/img/next.png" /></a>
              </li>
              <li class="edit-view" (mouseleave)="openFolderPanelHide()" (click)="rename(bookMarkList)">
                <img src="/assets/img/tools/edit2.png" /><span> Rename</span>
              </li>
              <li class="delete-view" (click)="delete()" (mouseleave)="openFolderPanelHide()">
                <img src="/assets/img/table/addRedX2.png" /><span> Delete</span>
              </li>
            </ul>

            <br />
            <span *ngIf="
                bookMarkList.view_label === defaultView.view_label ||
                (messagedefaultBookMark.id === bookMarkList.id &&
                  showDefaultMark)
              " id="default-span-702" style="font-size: 11px; opacity: 0.7">This is your default opening view</span>
          </li>
        </ul>
      </ng-container>
      <!-- {{contents}} -->

      <!-- {{contents}} -->
      <mat-accordion multi>
        <mat-expansion-panel hideToggle="true" (opened)="mainFolderActive" (closed)="!mainFolderActive">
          <mat-expansion-panel-header (click)="mainFodler()">
            <mat-panel-title class="base">
              Folders
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon class="arrow_icon" *ngIf="mainFolderActive">arrow_drop_down
              </mat-icon>
              <mat-icon class="arrow_icon" *ngIf="!mainFolderActive">arrow_drop_up
              </mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <ng-container *ngIf="mainFolderActive">
            <ng-container *ngFor="let folderList of bookMarkFolderView; index as i">
              <ul class="topFolderlist">
                <li class="allFolders d-flex flex-row align-items-center save-view-li-item" style="display: flex"
                  id="bookMarkFolder-{{ i }}">
                  <div class="folder-list">
                    <div class="folder-text">
                      <span class="title" title="{{folderList.title}}{{'\n'}}{{folderList.sub_title}}">{{
                        (folderList.title | slice: 0:14) +
                        (folderList.title.length > 14 ? "..." : "")
                        }}</span>
                      <span class="sub-title">{{
                        (folderList.sub_title | slice: 0:14) +
                        (folderList.sub_title.length > 14 ? "..." : "")
                        }}</span>
                    </div>
                    <div class="users-pro">
                      <div style="width: 34px;">
                        <img class="action-menu-btn" src="/assets/img/table/3doticon.png"
                          (click)="showFolderPanel(i, folderList)" (click)="getPositionFolder(i)" />
                      </div>
                      <a (click)="activeButton(i)">
                        <mat-icon class="arrow_icon1" *ngIf="!isActive[i]">arrow_drop_up</mat-icon>
                        <mat-icon class="arrow_icon1" *ngIf="isActive[i]">arrow_drop_down</mat-icon>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
              <div id="save-view-view-1" *ngIf="showFolder === i && hidePanel">
                <div class="multi-delete-view">
                  <ul class="update-view" id="actionMenuFolder{{ i }}">
                    <li (click)="updateFolder(i)" style="padding: 5px 10px !important; border-bottom: none;">
                      <img src="/assets/img/tools/edit2.png" /><span> Edit</span>
                    </li>
                    <li (click)="deleteFolder(i)">
                      <img src="/assets/img/table/addRedX2.png" /><span>
                        Delete</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div *ngIf="(editFolder && showFolder === i) || (deleteFolderModal && showFolder === i)">
                <div id="FolderExpansionMenu{{ i }}"
                  [ngClass]="editFolder ?  'modal-content-edit' : 'modal-content-delete'">
                  <div class="modal-body modal-padding">
                    <h5 *ngIf="editFolder && !deleteFolderModal">Edit Folder</h5>
                    <h5 *ngIf="!editFolder && deleteFolderModal">Confirm Delete</h5>
                    <p *ngIf="!editFolder && deleteFolderModal">Are you sure you want to delete this folder and all of
                      its
                      content?</p>
                    <input *ngIf="editFolder && !deleteFolderModal" id="rename-view-title" [(ngModel)]="title"
                      class="panel-text-box1" maxlength="100" placeholder="Enter title here" type="text">
                    <input *ngIf="editFolder && !deleteFolderModal" id="rename-view-title" [(ngModel)]="subText"
                      class="panel-text-box1" maxlength="100" placeholder="Enter subtitle here" type="text">
                    <div class="button-wrapper" *ngIf="editFolder && !deleteFolderModal">
                      <button class="modal-button-style" id="rename_button" data-dismiss="modal" viewid="721"
                        viewindex="0" (click)="saveEditFolder()">Save</button>
                      <button class="modal-button-style" data-dismiss="modal" (click)="close()">Cancel</button>
                    </div>
                    <div class="button-wrapper" *ngIf="!editFolder && deleteFolderModal">
                      <button (click)="deleteFolderPop()" class="modal-button-style" id="rename_button"
                        data-dismiss="modal" viewid="721" viewindex="0">
                        Yes
                      </button>
                      <button class="modal-button-style" data-dismiss="modal" (click)="close()">Cancel</button>
                    </div>
                  </div>
                </div>
              </div>

              <ul *ngIf="isActive[i]">
                <ng-container *ngFor="let ViewsList of folderList.bookmark; index as t">
                  <!-- t is replaced by t+folderList.bookmark.length*ViewsList.id for uniqueness-->
                  <li class="save-view-li-item" id="bookMarkPanel-{{ ViewsList.id }}"
                    (click)="selectMultiPleBookMarkFolder($event, ViewsList, t+folderList.bookmark.length*ViewsList.id)">
                    <span>
                      <a class="save-view-item"
                        [ngClass]="clickedIndexFolder === t+folderList.bookmark.length*ViewsList.id ? 'activeBtn' : ''"
                        (click)="clickToZoomFolder($event,ViewsList, t+folderList.bookmark.length*ViewsList.id)"
                        [ngClass]="
                          ViewsList.view_label === defaultView.view_label ||
                          (messagedefaultBookMark.id === ViewsList.id &&
                            showDefaultMark)
                            ? 'save-view-item-bold'
                            : 'save-view-item'
                        ">{{ ViewsList.view_label }}</a>
                    </span>
                    <img class="action-menu-btn" src="/assets/img/table/3doticon.png" (mouseout)="openPanelHide()"
                      (click)="showPanelFolder(t+folderList.bookmark.length*ViewsList.id+ViewsList.id, ViewsList)"
                      (click)="getPositionPanel(ViewsList.id)" />
                    <ul *ngIf="clicked[ViewsList.id]" class="option-buttons" id="actionMenuPanel{{ ViewsList.id }}">
                      <ul class="foldersPanel" id="actionMenuPanel{{ ViewsList.id }}" *ngIf="openPanels">
                        <li *ngFor="let folder of bookMarkFolderView; index as m">
                          <span>
                            <a [ngClass]="
                                folder.id === folderList.id
                                  ? 'save-view-item-disabled'
                                  : 'save-view-item'
                              " (click)="moveBookmark(folder)">{{ folder.title }}</a>
                          </span>
                        </li>
                        <span style="padding-left: 10px" (click)="removeFromFolder()">{{ removeFolder }}</span>
                      </ul>
                      <li (mouseout)="openPanelHide()" (click)="setDefaultView(ViewsList); selectedRow = t"
                        class="default-view default-save mytooltip _tooltip" id="740-def"
                        style="border-bottom: 1px solid #000 !important">
                        <img src="/assets/img/tools/default.png" /><span class="def-txt">
                          {{ status }} Default View</span>
                      </li>
                      <li class="edit-view">
                        <img src="/assets/img/folder.png" /><span> Folder</span>
                        <a class="next-win" (mouseover)="openPanel()"><img src="/assets/img/next.png" /></a>
                      </li>
                      <li class="edit-view" (click)="rename(ViewsList)" (mouseout)="openPanelHide()">
                        <img src="/assets/img/tools/edit2.png" /><span>
                          Rename</span>
                      </li>
                      <li class="delete-view" (click)="delete()" (mouseout)="openPanelHide()">
                        <img src="/assets/img/table/addRedX2.png" /><span>
                          Delete</span>
                      </li>
                    </ul>

                    <br />
                    <span *ngIf="
                        ViewsList.view_label === defaultView.view_label ||
                        (messagedefaultBookMark.id === ViewsList.id &&
                          showDefaultMark)
                      " id="default-span-702" style="font-size: 11px; opacity: 0.7">This is your default opening
                      view</span>
                  </li>
                </ng-container>
              </ul>
            </ng-container>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>


    </div>
  </div>
</div>
<div class="buttonDiv">
  <a class="closer closerToolTip">
    <img (click)="closeLeft()" class="closer-img common-btns tool-toolTip" src="/assets/img/tools/close-pv3.png"
      alt="closer" /><span class="tooltiptext tip-bottom"
      [innerHtml]="mapService.templatetoolTips['close_left_panel']"></span>
    <div *ngIf="showDeleteIcon" (click)="deleteMultiple()" class="multi-delete-view-button"><span> Delete</span>
    </div>
  </a>
</div>